module.exports = __webpack_public_path__ + "static/media/suitcase.7074b784.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/src/assets/images/icons/suitcase.svg
// module id = 2028
// module chunks = 71